export default __webpack_public_path__ + "static/media/idea-bat-animation.714e09e6.gif";